module.exports = __webpack_public_path__ + "static/media/sundat_express.2eef4386.png";